export var SlidingPaneIconOrder;
(function (SlidingPaneIconOrder) {
    SlidingPaneIconOrder["isAddAlert"] = "isAddAlert";
    SlidingPaneIconOrder["isAddToWatchlist"] = "isAddToWatchlist";
    SlidingPaneIconOrder["isViewQuote"] = "isViewQuote";
    SlidingPaneIconOrder["isQuote"] = "isQuote";
    SlidingPaneIconOrder["isReadReport"] = "isReadReport";
    SlidingPaneIconOrder["isOptionChain"] = "isOptionChain";
    SlidingPaneIconOrder["isGtdOrder"] = "isGtdOrder";
    SlidingPaneIconOrder["isUnpin"] = "isUnpin";
    SlidingPaneIconOrder["isMore"] = "isMore";
    SlidingPaneIconOrder["ispledge"] = "isPledge";
    SlidingPaneIconOrder["isAif"] = "isAif";
    SlidingPaneIconOrder["isChart"] = "isChart";
})(SlidingPaneIconOrder || (SlidingPaneIconOrder = {}));
